import { AgGridReact } from "ag-grid-react";
import {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import AsyncSelect from "react-select/async";

import { useTranslation } from "react-i18next";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./po-ag-grid-style.css";

//import AgProductSearchEditor from "./AgProductSearchEditorForPO";
import { AgentUtils } from "../../utils/AgentUtils";
import CheckboxRenderer from "./CheckboxRenderer";
import AgProductSearchEditor from "./AgProductSearchEditor";
import AgProductRenderor from "../sale/AgProductRenderor";
import AgActionButtonRenderor from "./AgActionButtonRenderor";
import FOCQtyRenderor from "./FOCQtyRenderor";
import AgSnCol from "./AgSnCol";

import { StringUtils } from "../../utils/StringUtils";

export default function AgGridQuickPurchaseList(props) {
  let numberOfRows = 2000;
  const [rowData] = useState(getRows(numberOfRows));

  let windowWidth =
    AgentUtils.getWindowDimensionsExAppBarsDualMode(props.context.appMode).w -
    53;

  const columnDefForQuick = [
    {
      headerName: "SN",
      field: "id",
      editable: false,
      cellRenderer: AgSnCol,
      cellRendererParams: {
        onLinkClikedForProductCrud: props.onLinkClikedForProductCrud,
      },
      width: (windowWidth * 5) / 100,
    },
    {
      headerName: "Item",
      field: "product",
      cellEditor: AgProductSearchEditor,
      cellRenderer: AgProductRenderor,
      //cellEditorPopup: true,
      cellEditorParams: {
        productCache: props.productCache,
        onProductSelected: onProductSelected,
        productType: "I",
        context: props.context,
      },
      onCellClicked: function suppressKey(event) {
        //console.log("EVENT", event);
        //gridRef.current.api.setFocusedCell(event.rowIndex, "product");
      },
      suppressKeyboardEvent: function suppressKey(params) {
        let KEY_ENTER = 13;
        let KEY_LEFT = 37;
        let KEY_UP = 38;
        let KEY_RIGHT = 39;
        let KEY_DOWN = 40;
        var event = params.event;
        var key = event.which;
        var editingKeys = [KEY_LEFT, KEY_RIGHT, KEY_UP, KEY_DOWN, KEY_ENTER];
        var suppress = params.editing && editingKeys.indexOf(key) >= 0;

        return suppress;
      },
      //cellEditorPopup: true,
      editable: true,
      width: 400,
      width: (windowWidth * 17) / 100,
    },
    {
      headerName: "UOM",
      field: "unitType",
      editable: false,
      type: "rightAligned",
      width: (windowWidth * 7) / 100,
    },
    {
      headerName: props.poType == "GRV" ? "Return Qty" : "Received Qty",
      field: "rQty",
      editable: true,
      type: "rightAligned",
      cellEditor: "agNumberCellEditor",
      cellEditorParams: {
        precision: 3,
      },
      valueParser: numberParser,
      width: (windowWidth * 7) / 100,
    },
    {
      headerName: "FOC",
      field: "foc",
      //editable: true,
      type: "rightAligned",
      cellRenderer: CheckboxRenderer,
      width: (windowWidth * 3) / 100,
    },
    {
      headerName: "F-QTY",
      field: "focQty",
      type: "rightAligned",
      cellRenderer: FOCQtyRenderor,
      editable: function (params) {
        return params.node.data.foc;
      },
      cellEditor: "agNumberCellEditor",
      cellEditorParams: {
        precision: 3,
      },
      valueParser: numberParser,
      width: (windowWidth * 4) / 100,
    },
    {
      headerName: props.poType == "GRV" ? "Return Cost" : "Received Cost",
      field: "rCost",
      editable: true,
      type: "rightAligned",
      cellEditor: "agNumberCellEditor",
      cellEditorParams: {
        precision: 3,
      },
      valueParser: numberParser,
      width: (windowWidth * 7) / 100,
    },
    {
      headerName: "Discount",
      field: "discount",
      editable: true,
      type: "rightAligned",
      cellEditor: "agNumberCellEditor",
      cellEditorParams: {
        precision: 3,
      },
      valueParser: numberParser,
      width: (windowWidth * 7) / 100,
    },
    {
      headerName: "Net Cost",
      field: "netCost",
      editable: false,
      type: "rightAligned",
      width: (windowWidth * 7) / 100,
    },
    {
      headerName: "Tax %",
      field: "taxPer",
      editable: false,
      type: "rightAligned",
      width: (windowWidth * 6) / 100,
    },

    {
      headerName: "Tax Type",
      cellEditor: "agSelectCellEditor",
      field: "taxType",
      cellEditorParams: {
        values: ["Include Tax", "Exclude Tax", "No tax"],
        valueListGap: 0,
      },
      editable: true,
      type: "rightAligned",
      width: (windowWidth * 7) / 100,
    },
    {
      headerName: "Tax",
      field: "tax",
      editable: false,
      type: "rightAligned",
      width: (windowWidth * 3) / 100,
    },
    {
      headerName: "Cost w/o Tax",
      field: "costWoTax",
      editable: false,
      type: "rightAligned",
      width: (windowWidth * 7) / 100,
    },
    {
      headerName: "Final Cost",
      field: "finalCost",
      editable: true,
      type: "rightAligned",
      cellEditor: "agNumberCellEditor",
      cellEditorParams: {
        precision: 3,
      },
      type: "rightAligned",
      width: (windowWidth * 7) / 100,
    },
    {
      headerName: "Action",
      field: "action",
      cellRenderer: AgActionButtonRenderor,
      editable: false,
      type: "rightAligned",
      width: (windowWidth * 3) / 100,
      onCellClicked: function suppressKey(event) {
        console.log("EVENT", event);
        onRemoveItemClicked(event.rowIndex);
        //gridRef.current.api.setFocusedCell(event.rowIndex, "product");
      },
      width: (windowWidth * 5) / 100,
    },
  ];
  const columnDefForRequest = [
    {
      headerName: "SN",
      field: "id",
      editable: false,
      cellRenderer: AgSnCol,
      cellRendererParams: {
        onLinkClikedForProductCrud: props.onLinkClikedForProductCrud,
      },
      width: (windowWidth * 5) / 100,
    },
    {
      headerName: "Item",
      field: "product",
      cellEditor: AgProductSearchEditor,
      cellRenderer: AgProductRenderor,
      //cellEditorPopup: true,
      cellEditorParams: {
        productCache: props.productCache,
        onProductSelected: onProductSelected,
        productType: "I",
        context: props.context,
      },
      onCellClicked: function suppressKey(event) {
        //console.log("EVENT", event);
        //gridRef.current.api.setFocusedCell(event.rowIndex, "product");
      },
      suppressKeyboardEvent: function suppressKey(params) {
        let KEY_ENTER = 13;
        let KEY_LEFT = 37;
        let KEY_UP = 38;
        let KEY_RIGHT = 39;
        let KEY_DOWN = 40;
        var event = params.event;
        var key = event.which;
        var editingKeys = [KEY_LEFT, KEY_RIGHT, KEY_UP, KEY_DOWN, KEY_ENTER];
        var suppress = params.editing && editingKeys.indexOf(key) >= 0;

        return suppress;
      },
      //cellEditorPopup: true,
      editable: true,
      width: 400,
      width: (windowWidth * 20) / 100,
    },
    {
      headerName: "UOM",
      field: "unitType",
      editable: false,
      type: "rightAligned",
      width: (windowWidth * 10) / 100,
    },
    {
      headerName: "Quantity",
      field: "rQty",
      editable: true,
      type: "rightAligned",
      cellEditor: "agNumberCellEditor",
      cellEditorParams: {
        precision: 3,
      },
      valueParser: numberParser,
      width: (windowWidth * 10) / 100,
    },

    {
      headerName: "Cost",
      field: "rCost",
      editable: true,
      type: "rightAligned",
      cellEditor: "agNumberCellEditor",
      cellEditorParams: {
        precision: 3,
      },
      valueParser: numberParser,
      width: (windowWidth * 10) / 100,
    },

    {
      headerName: "Tax %",
      field: "taxPer",
      editable: false,
      type: "rightAligned",
      width: (windowWidth * 10) / 100,
    },
    {
      headerName: "Tax ",
      field: "tax",
      editable: false,
      type: "rightAligned",
      width: (windowWidth * 10) / 100,
    },
    {
      headerName: "Cost w/o Tax",
      field: "costWoTax",
      editable: false,
      type: "rightAligned",
      width: (windowWidth * 10) / 100,
    },
    {
      headerName: "Final Cost",
      field: "finalCost",
      cellEditor: "agNumberCellEditor",
      cellEditorParams: {
        precision: 3,
      },
      type: "rightAligned",
      width: (windowWidth * 10) / 100,
    },
    {
      headerName: "Action",
      field: "action",
      cellRenderer: AgActionButtonRenderor,
      editable: false,
      type: "rightAligned",
      width: (windowWidth * 3) / 100,
      onCellClicked: function suppressKey(event) {
        console.log("EVENT", event);
        onRemoveItemClicked(event.rowIndex);
        //gridRef.current.api.setFocusedCell(event.rowIndex, "product");
      },
      width: (windowWidth * 5) / 100,
    },
  ];

  const [gridApi, setGridApi] = useState();
  const gridRef = useRef();

  const { t } = useTranslation();
  const translate = t;

  const rowClassRules = useMemo(() => {
    return {
      // row style function
      selected_sale: (params) => {
        return params.data.selected;
        //var numSickDays = params.data.sickDays;
        //return numSickDays > 5 && numSickDays <= 7;
      },
      // row style expression
    };
  }, []);

  useEffect(() => {
    if (props.data.length > 0) {
      if (props.data.length > numberOfRows) {
        numberOfRows = props.data.length + 10;
      }
      updateAgGrid(gridRef.current.api);
    } else {
      clearGrid();
    }
  }, [props.data, gridRef.current]);

  useEffect(() => {
    console.log("#AG1", props.data);
  }, [props.data]);

  var biRef = {};

  props.biRef.saleListAg = {
    parentEvent: parentEvent,
  };

  function parentEvent(event, value1, value2, value3) {
    if (event === "getCurrentRow") {
      if (gridRef.current && gridRef.current.api) {
        return gridRef.current.api.getSelectedNodes();
      }
    }
  }

  function clearGrid() {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.setRowData(getRows(numberOfRows));
    }
  }

  async function updateAgGrid(api) {
    const agGridData = [];

    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.forEachNodeAfterFilterAndSort(function (
        rowNode,
        index
      ) {
        const data = rowNode.data;
        agGridData.push(data);
      });
      let itemsToUpdate = [];
      let i = 0;
      let selectedIx = 0;
      for (let d of props.data) {
        if (!isMatching(d, agGridData[i])) {
          //console.log("MATCH CHECK Updating", d[1].v);
          itemsToUpdate.push(getAgGridData(d, agGridData[i]));
          if (d[13].info.selected) {
            selectedIx = i;
          }
        }
        i++;
      }
      for (let j = i; j < numberOfRows; j++) {
        let exists = isDataFound(agGridData, j);
        if (exists) {
          itemsToUpdate.push(getBlankData(agGridData[j]));
        }
      }
      //Reconcile
      if (itemsToUpdate.length > 0) {
        const res = gridRef.current.api.applyTransaction({
          update: itemsToUpdate,
        });
      }

      //gridRef.current.api.sizeColumnsToFit();
      //
    } else {
      while (true) {
        if (gridRef.current && gridRef.current.api) {
          await updateAgGrid();
          console.log("Waiting for API");
          break;
        }
        await sleep(100);
      }
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function getTableBodyHeight() {
    return (
      AgentUtils.getWindowDimensionsExAppBarsDualMode(props.context.appMode).h -
      200 +
      "px"
    );
  }

  function isDataFound(agGridData, i) {
    if (agGridData[i].product) {
      return true;
    }
    return false;
  }

  function isMatching(data, agRow) {
    //console.log("MATCH CHECK", data, agRow);
    if (data[1].v != agRow?.product?.prodBean?.name) return false;
    if (data[3].v != agRow.rQty) return false;
    if (data[4].v.foc != agRow.foc) return false;
    if (data[4].v.focQty != agRow.focQty) return false;
    if (data[5].v != agRow.rCost) return false;
    if (data[6].v != agRow.discount) return false;
    if (data[7].v != agRow.netCost) return false;
    if (data[8].v != agRow.taxPer) return false;
    if (data[9].v.name != agRow.taxType) return false;
    if (data[10].v != agRow.tax) return false;
    if (data[11].v != agRow.costWoTax) return false;
    if (data[12].v != agRow.finalCost) return false;
    if (data[13]?.info?.selected != agRow.selected) return false;
    return true;
  }

  function getBlankData(agRow) {
    agRow["product"] = null;
    agRow["unitType"] = null;
    agRow["rQty"] = null;
    agRow["foc"] = null;
    agRow["focQty"] = null;
    agRow["price"] = null;
    agRow["rCost"] = null;
    agRow["discount"] = null;
    agRow["netCost"] = null;
    agRow["taxPer"] = null;
    agRow["taxType"] = null;
    agRow["tax"] = null;
    agRow["costWoTax"] = null;
    agRow["finalCost"] = null;
    agRow["selected"] = null;
  }
  function getAgGridData(d, agRow) {
    agRow["product"] = {
      prodBean: d[13].info.productBean,
      pricingBean: d[13].info.pricingBean,
    };

    agRow["unitType"] = d[2].v;
    agRow["rQty"] = d[3].v;
    agRow["foc"] = d[4].v.foc;
    agRow["focQty"] = d[4].v.focQty;
    agRow["price"] = d[3].v;
    agRow["rCost"] = d[5].v;
    agRow["discount"] = d[6].v;
    agRow["netCost"] = d[7].v
      ? StringUtils.formattedNumber(d[7].v, props.context.store.currencyDecimal)
      : 0;
    agRow["taxPer"] = d[8].v;
    agRow["taxType"] = d[9].v.name;
    agRow["tax"] = d[10].v;
    agRow["costWoTax"] = d[11].v;
    agRow["finalCost"] = d[12].v;
    agRow["selected"] = d[13].info.selected ? true : false;

    return agRow;
  }

  function getRows(count) {
    let arr = [];
    for (let i = 0; i < count; i++) {
      arr.push({ id: i + 1 });
    }
    return arr;
  }

  const defaultColDef = useMemo(() => {
    return {
      cellStyle: {
        fontSize: "14px",
        paddingLeft: "0px",
        paddingRight: "0px",
      },
      headerStyle: {
        fontSize: "10px",
        paddingLeft: "7px",
        paddingRight: "7px",
      },
    };
  }, []);

  function onProductSelected(prodBean, pricingBean, rowId) {
    gridRef.current.api.stopEditing(true);
    const focusedRow = gridRef.current.api.getFocusedCell();

    if (focusedRow) {
      let ix = props.getItemIndex(prodBean.id, props.data);
      if (ix != null && props.isConsolidated) {
        gridRef.current.api.setFocusedCell(ix, "rQty");
        let d = [...props.data];
        props.resetSelection(d, ix);
        props.updatePurchaseItemData(d);
      } else {
        if (!props.data[focusedRow.rowIndex]) {
          props.onAddProduct(prodBean, pricingBean);
          gridRef.current.api.setFocusedCell(focusedRow.rowIndex, "rQty");
        } else {
          props.onAddProduct(prodBean, pricingBean, rowId - 1);
          gridRef.current.api.setFocusedCell(focusedRow.rowIndex, "rQty");
        }
      }
    }
  }

  function onRemoveItemClicked(rowIndex) {
    let data = [...props.data];

    data.splice(rowIndex, 1);
    let index = 0;
    data.map((item) => {
      data[index][0].v = index + 1;
      index++;
    });
    //resetSelection(data, rowIndex);
    props.updatePurchaseItemData(data);
  }

  function numberParser(params) {
    return Number.isNaN(Number(params.newValue))
      ? params.oldValue
      : Number(params.newValue);
  }
  const onCellValueChanged = (event) => {
    console.log("On Cell Value Changes ", event);
    let d = [...props.data];
    let updated = false;
    if (event.column.colId === "rQty") {
      props.updatevalues(
        d[event.rowIndex],
        "RECEIVED_QTY",
        { v: event.newValue },
        null
      );
      updated = true;
    } else if (event.column.colId === "foc") {
      let d = [...props.data];
      props.updatevalues(
        d[event.rowIndex],
        "foc",
        { v: { foc: event.newValue, focQty: d[event.rowIndex][4].v.focQty } },
        null
      );
      updated = true;
    } else if (event.column.colId === "focQty") {
      let d = [...props.data];
      props.updatevalues(
        d[event.rowIndex],
        "foc",
        { v: { focQty: event.newValue, foc: d[event.rowIndex][4].v.foc } },
        null
      );
      updated = true;
    } else if (event.column.colId === "rCost") {
      let d = [...props.data];
      props.updatevalues(
        d[event.rowIndex],
        "RECEIVED_COST",
        { v: event.newValue },
        null
      );
      updated = true;
    } else if (event.column.colId === "discount") {
      let d = [...props.data];
      props.updatevalues(
        d[event.rowIndex],
        "DISCOUNT",
        { v: event.newValue },
        null
      );
      updated = true;
    } else if (event.column.colId === "taxType") {
      let d = [...props.data];
      let id = null;
      if (event.newValue == "Include Tax") {
        id = "1";
      } else if (event.newValue == "Exclude Tax") {
        id = "2";
      }
      if (event.newValue == "No Tax") {
        id = "3";
      }
      props.updatevalues(
        d[event.rowIndex],
        "TAX_CHANGE",
        { name: event.newValue, id: id },
        null
      );
      updated = true;
    } else if (event.column.colId === "product") {
      let d = [...props.data];

      updated = true;
    } else if (event.column.colId === "finalCost") {
      let d = [...props.data];
      props.updatevalues(
        d[event.rowIndex],
        "FINAL_COST",
        { v: event.newValue },
        null
      );
      updated = true;
    }
    props.updatePurchaseItemData(d);
  };

  const onGridReady = (e) => {
    setGridApi(e.api);
  };

  return (
    <div
      className="ag-theme-alpine"
      style={{ height: getTableBodyHeight(), width: "100%" }}
    >
      {(props.poType == "GRN" || props.poType == "GRV") && (
        <AgGridReact
          onGridReady={onGridReady} // register event listener
          ref={gridRef}
          rowHeight={"10px"}
          rowData={rowData}
          columnDefs={columnDefForQuick}
          onCellValueChanged={onCellValueChanged}
          rowSelection="single"
          defaultColDef={defaultColDef}
          rowClassRules={rowClassRules}
        ></AgGridReact>
      )}
      {props.poType == "LPO" && (
        <AgGridReact
          onGridReady={onGridReady} // register event listener
          ref={gridRef}
          rowHeight={"10px"}
          rowData={rowData}
          columnDefs={columnDefForRequest}
          onCellValueChanged={onCellValueChanged}
          rowSelection="single"
          defaultColDef={defaultColDef}
          rowClassRules={rowClassRules}
        ></AgGridReact>
      )}
    </div>
  );
}
